<template>
  <div>
    <div v-if="isDevEnv" style="margin-bottom: 16px;">
      <b-button variant="outline-primary" @click="fillTestData" :disabled="disabledFields">Preencher dados de teste</b-button>
    </div>
    <b-form-group
      :label="'A) ' + $t('coup_attempt_type')"
      label-for="incidentCoupAttemptTypeListSelected">
      <validation-provider
        #default="{ errors }"
        :name="$t('coup_attempt_type')"
        rules="required">
          <b-form-checkbox-group
            v-model="incidentCoupAttemptTypeListSelected"
            :options="coupAttemptTypeList"
            value-field="id"
            text-field="name"
            name="incidentCoupAttemptTypeListSelected"
            :disabled="disabledFields"
            stacked/>
              <b-form-input v-if="enableCoupAttemptTypeOther"
                id="otherCoupAttempt"
                v-model="otherCoupAttempt"
                :state="errors.length > 0 ? false:null"
                name="coupAttemptOther"
                :disabled="disabledFields"
                class="mt-1"/>
            <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!--Responsible Email-->
    <b-form-group
      :label="'B) ' + $t('incident_form_responsible_email')"
      label-for="incident_form_responsible_email">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_responsible_email')"
              rules="required|email">
          <b-form-input
            id="incident_form_responsible_email"
            v-model="responsibleEmail"
            :state="errors.length > 0 ? false:null"
            name="responsibleEmail"
            class="required"
            :disabled="disabledFields"
            type="email"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- incident Date -->
    <b-form-group
      :label="'C) ' + $t('incident_form_date_coup_attempt')"
      label-for="incident_date">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_date_coup_attempt')"
          rules="required">
          <flat-pickr
            v-model="incidentDate"
            class="form-control required"
            :class="{ 'is-disabled': disabledFields }"
            :config="configCalendar"
            :disabled="disabledFields"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Unity -->
    <b-form-group
      :label="'D) ' + $t('incident_form_unit')"
      label-for="unity">
        <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_unit')"
          rules="required">
          <v-select v-model="legalEntity" :options="listLegal" label="name" class="required-select" :disabled="disabledFields">
            <div slot="no-options">{{$t('msg_none')}}</div>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>

    <!-- Description -->
    <b-form-group
      :label="'E) ' + $t('incident_form_description_coup_attempt')"
      label-for="incident_form_description_coup_attempt">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_description_coup_attempt')"
          rules="required">
        <b-form-textarea
          id="incident_form_description_coup_attempt"
          v-model="descriptionIncident"
          :state="errors.length > 0 ? false:null"
          :placeholder="$t('incident_form_min_caracter')"
          :disabled="disabledFields"
          rows="4"/>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <!-- Involved -->
    <b-form-group
      :label="'F) ' + $t('incident_form_who_reported_coup_attempt')+$t('incident_form_name_tel_email')"
      label-for="incident_form_who_reported">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_who_reported_coup_attempt')"
          rules="required">
          <b-form-textarea
            id="incident_form_who_reported_coup_attempt"
            v-model="whoReported"
            :state="errors.length > 0 ? false:null"
            :placeholder="$t('incident_form_min_caracter')"
            name="whoReported"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Responsible Unit -->
    <b-form-group
      :label="'G) ' + $t('incident_form_responsible_unit')+$t('incident_form_name_tel_email')"
      label-for="incident_form_responsible_unit">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_responsible_unit')"
          rules="required">
          <b-form-textarea
            id="incident_form_responsible_unit"
            v-model="responsibleUnit"
            :state="errors.length > 0 ? false:null"
            name="responsibleUnit"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- How Detected -->
    <b-form-group
      :label="'H) ' + $t('incident_form_how_identified')"
      label-for="incident_form_how_identified">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_how_identified')"
          rules="required">
          <b-form-textarea
            id="incident_form_how_identified"
            v-model="howIdentified"
            :state="errors.length > 0 ? false:null"
            name="howIdentified"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import standard from '@/services/standard'

import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null
    },
    typeForm: {
      type: String,
      default: null
    },
    dataForm: {
      type: Object,
      default: null
    },
    disabledFields: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      //
      incidentDate: '',
      whoReported: '',
      descriptionIncident: '',
      responsibleUnit: '',
      howIdentified: '',
      responsibleEmail: '',
      //
      coupAttemptTypeList: [],
      incidentCoupAttemptTypeListSelected: [],
      otherCoupAttempt: '',
      legalEntity: null,
      legalEntityList: [],
      legalEntityOriginId: '',
      //Services
      services: {
        requestFormIncidentService : null,
      },
      isDevEnv: [
        'localhost',
        '127.0.0.1',
        '0.0.0.0',
        'dev',
        'teste',
        'test',
        'homolog',
        'homologacao',
        'staging'
      ].some(env => window.location.hostname.includes(env)),
    }
  },

  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.incidentCoupAttemptTypeListSelected)
      )
    },
    enableCoupAttemptTypeOther() {
      return this.incidentCoupAttemptTypeListSelected ? this.incidentCoupAttemptTypeListSelected.indexOf(9) != -1 : false
    },
    listLegal(){
       this.legalEntityList.push({
        id: null,
        name: "Outras",
        trading_name: "Outras"
      })
      return this.legalEntityList
    },
    getLocale() {
      return this.$i18n.locale
    },
    configCalendar() {
      return {
        wrap: true,
        enableTime: false,
        allowInput: true,
        ariaDateFormat: 'DD/MM/YYYY',
        dateFormat: "DD/MM/YYYY",
        altFormat: "DD/MM/YYYY",
        allowInput: true,
        parseDate: (datestr, format) => {
          return this.$moment(datestr, format, true).toDate();
        },
        formatDate: (date, format, locale) => {
          // locale can also be used
          return this.$moment(date).format(format);
        },
        locale: require(`flatpickr/dist/l10n/${this.getLocale}.js`).default[this.getLocale]
      }
    }
  },
  watch: {
    enableCoupAttemptTypeOther(value){
      if(value === false){
        this.otherCoupAttempt = null
      }
      console.log(value, this.otherCoupAttempt)
    },
    dataForm: {
      handler(newValue) {
        if (newValue) {
          this.handleDataForm();
          this.loadLegalEntityList()
        }
      },
      immediate: true
    },
    typeForm: {
      handler(newValue) {
        // Quando o tipo de formulário muda, recarregar a lista de entidades legais
        if (newValue && this.services.requestFormIncidentService) {
          this.loadLegalEntityList()
        }
      },
      immediate: false
    }
  },
  methods: {
    loadLegalEntityList(){
      // Verificar se o serviço foi inicializado
      if (!this.services.requestFormIncidentService) {
        console.log('loadLegalEntityList - service not initialized yet')
        return
      }

      this.$vs.loading()
      console.log('loadLegalEntityList - param_encrypt:', this.param_encrypt)
      console.log('loadLegalEntityList - legalEntityOriginId:', this.legalEntityOriginId)

      this.services.requestFormIncidentService.getListLegalEntity(this.param_encrypt, this.legalEntityOriginId).then(
        data => {
          console.log('loadLegalEntityList - success:', data)
          this.legalEntityList = data.list
        }
      ).catch(error => {
        console.error('loadLegalEntityList - error:', error)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    clearFields(){
      this.incidentDate = null
      this.whoReported = null
      this.descriptionIncident = null
      this.responsibleUnit = null
      this.howIdentified = null
      this.otherCoupAttempt = null
      this.legalEntity = null
      this.legalEntityOriginId = ''
      this.responsibleEmail = null
      //Arrays
      this.incidentCoupAttemptTypeListSelected = []

      this.$nextTick( () => {this.clearErrors(this.$validator)})
    },
    getFormData() {
      return {
        incidentDate: this.incidentDate,
        whoReported: this.whoReported,
        descriptionIncident: this.descriptionIncident,
        responsibleUnit: this.responsibleUnit,
        howIdentified: this.howIdentified,
        otherCoupAttempt: this.otherCoupAttempt,
        legalEntityId: this.legalEntity ? this.legalEntity.id : null,
        responsibleEmail: this.responsibleEmail,
        //
        incidentCoupAttemptTypeListSelected: this.incidentCoupAttemptTypeListSelected
      }
    },
    fillTestData() {
      this.incidentDate = '01/01/2024';
      this.whoReported = 'Usuário Teste';
      this.descriptionIncident = 'Descrição teste';
      this.responsibleUnit = 'Responsável Teste';
      this.howIdentified = 'Detectado por Teste';
      this.incidentCoupAttemptTypeListSelected = [1, 3, 9];
      this.otherCoupAttempt = 'Outro tipo';
      this.legalEntity = { id: 1, name: 'Empresa Teste' };
      this.responsibleEmail = 'teste@teste.com';
    },
    handleDataForm(){
      if(this.dataForm){
        this.incidentDate = this.dataForm.incident_date
        this.whoReported = this.dataForm.who_reported
        this.descriptionIncident = this.dataForm.description
        this.responsibleUnit = this.dataForm.responsible_unit
        this.howIdentified = this.dataForm.how_identified
        this.legalEntity = this.dataForm.legal_entity ? this.dataForm.legal_entity : this.legalEntityList[this.legalEntityList.length - 1]
        this.legalEntityOriginId = this.dataForm.legal_entity_origin_id
        this.responsibleEmail = this.dataForm.responsible_email
        //Arrays
        this.incidentCoupAttemptTypeListSelected = this.dataForm.incident_coup_attempt_types ? this.dataForm.incident_coup_attempt_types.map(type => type.id) : []
        this.otherCoupAttempt = this.dataForm.other_coup_attempt ||  ''
      }
    }
  },
  mounted() {
    console.log(this.dataForm)
    // handleDataForm() is now handled by the dataForm watcher

    // Carregar a lista de entidades legais quando não há dataForm (formulário novo)
    if (!this.dataForm && this.services.requestFormIncidentService) {
      this.loadLegalEntityList()
    }
  },
  beforeMount() {
    const promisses = []

    //Services
    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)

    promisses.push(
      this.services.requestFormIncidentService.getListIncidentCoupAttemptType().then(
        data => {
          this.coupAttemptTypeList = data
        },
        error => {
          console.log(error)
        }
      ).finally(() => {
        this.$vs.loading.close()
      })
    )

    Promise.all(promisses).then(() => {
      // Tentar carregar a lista de entidades legais depois que o serviço estiver inicializado
      if (this.dataForm) {
        this.loadLegalEntityList()
      }
    })

  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .is-disabled {
    pointer-events: none;
    opacity: 0.65;
    cursor: not-allowed;
  }

</style>

